export default __webpack_public_path__ + "static/media/breakfast1.029174ce.png";